define([
    'lodash',
    'utils',
    'coreUtils'
], function (_, utils, coreUtils) {
    'use strict';

    const siteUtils = utils.siteUtils;

    const getPageBackgroundData = (page, pageId, masterPage) => {
        const backgroundItemPointers = siteUtils.getPageBackgroundDataPointers(masterPage, [pageId]);
        return backgroundItemPointers.reduce((pageAccumData, {path}) => {
            const bgDataItem = _.get(masterPage, path);
            if (bgDataItem) {
                _.set(pageAccumData, path, _.get(masterPage, path));
                _.unset(masterPage, path);
            }
            return pageAccumData;
        }, {});
    };

    const extractBackgroundFromPages = (accumMasterPageData, serializedPage, pageId) => {
        const dataPointers = siteUtils.getPageBackgroundDataPointers(serializedPage.content, [pageId]);
        dataPointers.forEach(({path}) => {
            const bgDataItem = _.get(serializedPage.content, path);
            if (bgDataItem) {
                _.set(accumMasterPageData, path, _.get(serializedPage.content, path));
                _.unset(serializedPage.content, path);
            }
        });
        return accumMasterPageData;
    };

    return {
        serialize: ({pagesData}) => {
            const masterPageDataItem = pagesData[coreUtils.siteConstants.MASTER_PAGE_ID];
            return {
                pages: _(pagesData)
                    .omit('masterPage')
                    .mapValues((page, pageId) => ({
                        content: getPageBackgroundData(page, pageId, masterPageDataItem)
                    }))
                    .value()
            };
        },
        deserialize: ({pages}) => {
            const masterPageDataItem = {data: {document_data: {}}};

            return {
                pagesData: {
                    masterPage: _(pages)
                        .omit('masterPage')
                        .reduce(extractBackgroundFromPages, masterPageDataItem)
                }
            };
        },
        getEncryptedPaths: payload => Object.keys(payload.pages).map(pageId => `pages.${pageId}.content`)
    };
});
